"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconUserCircleActive = Experimental__IconUserCircleActive;
exports.IconUserCircleActive = IconUserCircleActive;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconUserCircleActive/index.tsx)
 */
function IconUserCircleActive(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm-3.594-3.964 1.471-.85A1.2 1.2 0 0 0 6.2 9.378l-.093-.111c-.545-.65-.92-1.394-.972-2.284-.03-.5.057-1.019.144-1.276.128-.379.321-.726.591-1.021a2.885 2.885 0 0 1 4.255 0c.27.295.463.642.592 1.021.087.257.174.776.144 1.276-.053.89-.428 1.634-.972 2.284l-.093.111a1.2 1.2 0 0 0 .321 1.808l1.472.85c.328.189.62.424.87.695A6.477 6.477 0 0 1 8 14.5a6.478 6.478 0 0 1-4.461-1.773 3.7 3.7 0 0 1 .867-.691Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm-5.022-5.954 2.368-1.388a1.5 1.5 0 0 0 .401-2.246l-.177-.217c-.7-.847-1.182-1.818-1.25-2.978-.038-.652.074-1.33.186-1.664a3.74 3.74 0 0 1 .76-1.333 3.71 3.71 0 0 1 1.24-.901 3.662 3.662 0 0 1 2.988 0c.47.21.893.517 1.24.901.347.385.595.839.76 1.333.113.335.224 1.012.186 1.664-.068 1.16-.55 2.131-1.25 2.978l-.177.217a1.5 1.5 0 0 0 .4 2.246l2.37 1.388a3.998 3.998 0 0 1 1.353 1.306A8.973 8.973 0 0 1 12 21a8.972 8.972 0 0 1-6.376-2.648 3.997 3.997 0 0 1 1.354-1.306Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconUserCircleActive is deprecated and will be archived soon. Use IconUserCircleActive instead.
 */
function Experimental__IconUserCircleActive(props) {
  return /*#__PURE__*/_react["default"].createElement(IconUserCircleActive, props);
}